import { render, staticRenderFns } from "./Certificate.vue?vue&type=template&id=4c522304&scoped=true&"
import script from "./Certificate.vue?vue&type=script&lang=ts&"
export * from "./Certificate.vue?vue&type=script&lang=ts&"
import style0 from "./Certificate.vue?vue&type=style&index=0&id=4c522304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c522304",
  null
  
)

export default component.exports